<template>
  <section class="daily-publish-quota">
    <div class="daily-publish-quota__heading" :class="{ 'daily-publish-quota__heading--standalone': !showHeading }">
      <h3 v-if="showHeading">观星树考核标准</h3>
      <span class="daily-publish-quota__off">未授权：0个 / 天</span>
    </div>
    <div class="daily-publish-quota__table-wrap">
      <table class="daily-publish-quota__table" aria-label="观星树考核标准">
        <colgroup><col class="daily-publish-quota__shop-col"><col><col></colgroup>
        <thead>
          <tr><th scope="col">店铺状态</th><th v-for="stage in stages" :key="stage.key" scope="col">{{ stage.label }}</th></tr>
        </thead>
        <tbody>
          <tr v-for="rule in quotaRules" :key="rule.key">
            <th scope="row">{{ rule.shop }}</th>
            <td v-for="stage in stages" :key="stage.key">
              <span class="daily-publish-quota__mobile-stage">{{ stage.label }}</span>
              <div class="daily-publish-quota__publish">每日上货 <strong>{{ rule[stage.key] }}</strong><span> 个 / 天</span></div>
              <p class="daily-publish-quota__cleanup">{{ stage.key === 'qualified' ? '不进行无销量商品清理' : '清理累计销量为0的商品' }}<span v-if="stage.key === 'unqualified'">近30天内创建，排除最近7天</span></p>
              <p v-if="stage.key === 'unqualified'" class="daily-publish-quota__scope">仅清理通过观星树上架的商品</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="daily-publish-quota__notes">
      <p>考核范围：北京时间近30个完整自然日，不含今天；仅统计通过观星树上架、同步时仍在架的商品。累计销量大于0的商品占比≥1%即达标。高动销店铺对应抖店标记的非低动销店铺。</p>
      <p>未达标时，清理近30天内创建、排除最近7天且累计销量为0的本系统铺货商品。例如今日{{ exampleDates.today }}：考核{{ exampleDates.start }}至{{ exampleDates.assessmentEnd }}创建的商品，清理{{ exampleDates.start }}至{{ exampleDates.cleanupEnd }}创建的商品。销量及在架状态取同步时最新值。</p>
      <p>未授权每日0个；已授权但缺少当前完整窗口的有效考核、考核不适用或店铺状态未知时，每日50个并暂停自动清理。</p>
      <p>今日剩余额度扣除今日成功数，新建任务还需扣除待执行占用。</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DailyPublishQuotaNotice',
  props: {
    showHeading: { type: Boolean, default: true }
  },
  data() {
    return {
      exampleDay: this.getBeijingDay(),
      dateRefreshTimer: null,
      stages: [
        { key: 'unqualified', label: '观星树未达标' },
        { key: 'qualified', label: '观星树达标（≥1%）' }
      ],
      quotaRules: [
        { key: 'low', shop: '低动销店铺', unqualified: 50, qualified: 300 },
        { key: 'normal', shop: '高动销店铺', unqualified: 50, qualified: 500 }
      ]
    }
  },
  computed: {
    exampleDates() {
      const [year, month, day] = this.exampleDay.split('-').map(Number)
      const today = Date.UTC(year, month - 1, day)
      const offsetDate = days => new Date(today + days * 86400000).toISOString().slice(0, 10)
      return { today: this.exampleDay, start: offsetDate(-30), assessmentEnd: offsetDate(-1), cleanupEnd: offsetDate(-8) }
    }
  },
  mounted() {
    this.dateRefreshTimer = window.setInterval(() => {
      this.exampleDay = this.getBeijingDay()
    }, 60000)
  },
  beforeDestroy() {
    window.clearInterval(this.dateRefreshTimer)
  },
  methods: {
    getBeijingDay() {
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date())
      const part = name => parts.find(item => item.type === name).value
      return `${part('year')}-${part('month')}-${part('day')}`
    }
  }
}
</script>

<style scoped>
.daily-publish-quota { color: #303744; font-size: 14px; line-height: 1.6; text-align: left; }
.daily-publish-quota h3, .daily-publish-quota p { margin: 0; }
.daily-publish-quota h3 { font-size: 16px; font-weight: 600; }
.daily-publish-quota__heading { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-bottom: 12px; }
.daily-publish-quota__heading--standalone { justify-content: flex-end; }
.daily-publish-quota__off { flex-shrink: 0; font-size: 12px; color: #7b8492; padding: 2px 8px; background: #f2f4f7; border-radius: 4px; }
.daily-publish-quota__table-wrap { position: relative; border: 1px solid #e7ebf1; border-radius: 8px; overflow: hidden; }
.daily-publish-quota__table { width: 100%; border-collapse: collapse; table-layout: fixed; }
.daily-publish-quota__shop-col { width: 22%; }
.daily-publish-quota__table thead th { padding: 12px 14px; background: #f7f8fa; font-size: 12px; font-weight: 500; color: #727b88; text-align: center; }
.daily-publish-quota__table thead th:first-child { text-align: left; }
.daily-publish-quota__table tbody th { padding: 20px 14px; border-top: 1px solid #edf0f4; font-size: 16px; font-weight: 500; text-align: left; vertical-align: middle; }
.daily-publish-quota__table td { padding: 20px 12px; border-top: 1px solid #edf0f4; text-align: center; vertical-align: middle; }
.daily-publish-quota__publish { color: #626b77; white-space: nowrap; }
.daily-publish-quota__publish strong { margin-left: 4px; color: #20252d; font-size: 24px; font-weight: 600; }
.daily-publish-quota__publish > span { color: #8b929c; font-size: 12px; }
.daily-publish-quota__table .daily-publish-quota__cleanup { margin-top: 10px; color: #67717e; font-size: 12px; }
.daily-publish-quota__cleanup > span { display: block; }
.daily-publish-quota__table .daily-publish-quota__scope { margin-top: 5px; color: #9299a3; font-size: 12px; }
.daily-publish-quota__mobile-stage { display: none; }
.daily-publish-quota__notes { margin-top: 14px; color: #7b8492; font-size: 12px; line-height: 1.7; }
.daily-publish-quota__notes p + p { margin-top: 4px; }
@media (max-width: 520px) {
  .daily-publish-quota__table-wrap { border: 0; border-radius: 0; overflow: visible; }
  .daily-publish-quota__table, .daily-publish-quota__table tbody { display: block; }
  .daily-publish-quota__table colgroup { display: none; }
  .daily-publish-quota__table thead { position: absolute; width: 1px; height: 1px; padding: 0; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; }
  .daily-publish-quota__table tbody tr { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); border: 1px solid #e7ebf1; border-radius: 8px; overflow: hidden; }
  .daily-publish-quota__table tbody tr + tr { margin-top: 12px; }
  .daily-publish-quota__table tbody th { grid-column: 1 / -1; padding: 10px 12px; border-top: 0; background: #f7f8fa; font-size: 14px; }
  .daily-publish-quota__table td { display: block; padding: 12px 8px; }
  .daily-publish-quota__table td + td { border-left: 1px solid #edf0f4; }
  .daily-publish-quota__mobile-stage { display: block; margin-bottom: 8px; color: #67717e; font-size: 11px; }
  .daily-publish-quota__publish { font-size: 12px; }
  .daily-publish-quota__publish strong { margin-left: 2px; font-size: 22px; }
  .daily-publish-quota__publish > span { font-size: 11px; }
}
</style>
